import { __generator } from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { request } from '../../xhr';
import { MediaSourceType } from '../types';
import { getCurrentMediaSource, getCurrentTierId } from '../selectors';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
export function fakeResponse(_a) {
    var params = _a.params;
    if (process.env.NODE_ENV !== 'production') {
        var deviationsByType = require('@wix/da-sample-data').deviationsByType; // eslint-disable-line global-require
        var Chance = require('chance').Chance; // eslint-disable-line global-require
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        var folderId = params.folderId, offset = params.offset, limit = params.limit;
        if (folderId === -999) {
            return {
                hasMore: false,
                nextOffset: 0,
                deviations: [],
            };
        }
        var randomDeviations = new Chance().pickset(deviationsByType.pixel
            .concat(deviationsByType.statuses)
            .concat(deviationsByType.image)
            .concat(deviationsByType.edgeCases)
            .concat(deviationsByType.journal)
            .concat(deviationsByType.literature), limit);
        return {
            hasMore: offset + limit < deviationsByType.image.length,
            nextOffset: offset + limit,
            deviations: randomDeviations.slice(0, limit),
        };
    }
}
function fetch(url, params) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: url,
                    params: params,
                }, fakeResponse)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}
function handleDeviationStreamFetch(action) {
    var streamId, _a, tierId, mediaSource, offset, limit, url, params, response, hasMore, results, nextOffset, normalized;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                streamId = action.streamId;
                return [4 /*yield*/, select(function (state) { return ({
                        tierId: getCurrentTierId(state),
                        mediaSource: getCurrentMediaSource(state),
                        offset: withOffset.selectors.getNextOffset(state, streamId),
                        limit: selectors.getItemsPerFetch(state, streamId),
                    }); })];
            case 1:
                _a = _d.sent(), tierId = _a.tierId, mediaSource = _a.mediaSource, offset = _a.offset, limit = _a.limit;
                url = 'tier/content';
                params = {
                    tier_deviationid: tierId,
                    section: mediaSource === MediaSourceType.TIER_DEVIATIONS ? 'deviations' : 'posts',
                    offset: offset,
                    limit: limit,
                    mature_content: true,
                };
                return [4 /*yield*/, call(fetch, url, params)];
            case 2:
                response = _d.sent();
                if (!!response) return [3 /*break*/, 4];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 3:
                _d.sent();
                return [2 /*return*/];
            case 4:
                hasMore = response.hasMore, results = response.deviations, nextOffset = response.nextOffset;
                normalized = results && normalizeDeviations(results);
                return [4 /*yield*/, put(withOffset.actions.fetchSuccessDeduped({
                        streamId: streamId,
                        hasMore: results ? !!hasMore : false,
                        items: (_b = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _b !== void 0 ? _b : [],
                        entities: (_c = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _c !== void 0 ? _c : {},
                        nextOffset: nextOffset !== null && nextOffset !== void 0 ? nextOffset : undefined,
                    }))];
            case 5:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
export default handleDeviationStreamFetch;
//# sourceMappingURL=tierDeviationStreamFetch.js.map